export * from "./src/paid-cta-primary";
export { PaidCtaPrimary as default } from "./src/paid-cta-primary";
